import { REPORT_FACETS_API } from 'constants/AppConstants';
import { constructUrlWithUserDetails } from 'utils/app.utils';

// #genai Name the default export without changing its signature or callers.
export default async function getReportFacets(reportId, signature) {
  const baseUrl = REPORT_FACETS_API.replace(':reportId', reportId);
  let URL = constructUrlWithUserDetails(baseUrl);
  if (signature) {
    URL += `${URL.includes('?') ? '&' : '?'}signature=${encodeURIComponent(signature)}`;
  }

  try {
    const response = await fetch(URL, { skipAuthHeader: true });
    const json = await response.json();
    if (response.status !== 200) return { ok: false, status: response.status, json };
    return { ok: true, status: response.status, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
}
